import { Box, Card, CardContent, Divider, List, ListItem, Tab } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import { MainContainer } from '../../style/GlobalStyles';
import { StyledTabs } from '../../components/CustomTabs';
import DocumentCardSkeleton from '../../components/DocumentCard/skeleton';

export const MemberSkeleton = (
    <>
        {Array.from(Array(2).keys()).map((_, index) => (
            <Skeleton key={index} variant="text" sx={{ height: '1.1rem', width: '35%' }}>
                <Skeleton variant="text" sx={{ height: '2rem', width: '20%', minWidth: '15rem' }} />
            </Skeleton>
        ))}
    </>
);

export const DocsSkeleton = (
    <Box
        sx={{
            marginTop: `2.25rem`,
        }}
    >
        <Skeleton variant="text" sx={{ height: '1.5rem', width: '20%' }} />

        <Box
            sx={(theme) => ({
                width: '100%',
                borderBottom: `1px solid ${theme.palette.border.neutralPrimary}`,
                display: 'flex',
                justifyContent: 'space-between',
            })}
        >
            <StyledTabs
                variant="scrollable"
                value={0}
                sx={{
                    '& .MuiTabs-indicator': {
                        backgroundColor: 'rgba(0,0,0,0.11)',
                    },
                }}
            >
                {Array.from(Array(3).keys()).map((value, index) => (
                    <Tab value={value} key={index} label={<Skeleton variant="text" sx={{ height: '1rem', width: '100%' }} />} iconPosition="end" />
                ))}
            </StyledTabs>
        </Box>
        <Box>
            <Box
                sx={(theme) => ({
                    display: 'flex',
                    flexWrap: 'wrap',
                    padding: `${theme.typography.generic.xSmall} ${theme.typography.generic.none}`,
                    marginLeft: `-${theme.typography.generic.xSmall}`,
                })}
            >
                {Array.from(Array(3).keys()).map((_, index) => (
                    <DocumentCardSkeleton key={index} />
                ))}
            </Box>
        </Box>
    </Box>
);
export const skeleton = (
    <>
        {/* <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'fixed', top: '0px', left: '0px', width: '100%', height: '100%', background: 'white' }}>
                <CircularProgress />
            </Box> */}
        <MainContainer>
            {/* Header */}
            <Box>
                <Skeleton variant="text" sx={{ height: '2rem', width: '20%', minWidth: '15rem' }} />
                <Skeleton variant="text" sx={{ height: '1.5rem', width: '40%', minWidth: '20rem' }} />
            </Box>

            <Box
                sx={(theme) => ({
                    marginTop: `${theme.typography.generic.xLarge}`,
                })}
            >
                <Card>
                    <CardContent>
                        <Box
                            display={'flex'}
                            flexDirection={{
                                xs: 'column',
                                md: 'row',
                            }}
                        >
                            <Box
                                display={'flex'}
                                rowGap={{
                                    xs: '1.5rem',
                                    sm: '2rem',
                                }}
                                flexDirection={{
                                    xs: 'column',
                                    sm: 'row',
                                }}
                                flexWrap={'wrap'}
                                width={{
                                    xs: '100%',
                                    md: '50%',
                                }}
                            >
                                {Array.from(Array(6).keys()).map((_, index) => (
                                    <Box
                                        key={index}
                                        sx={{
                                            width: { sm: '50%', xs: '100%' },
                                        }}
                                    >
                                        <Skeleton variant="text" sx={{ height: '1rem', width: { sm: '30%', xs: '50%' } }} />
                                        <Skeleton variant="text" sx={{ height: '1.1rem', width: { sm: '40%', xs: '70%' } }} />
                                    </Box>
                                ))}
                            </Box>
                            <Box
                                width={{
                                    xs: '100%',
                                    md: '50%',
                                }}
                                marginTop={(theme) => ({
                                    xs: theme.typography.generic.xxxxxLarge,
                                    md: theme.typography.generic.unset,
                                })}
                            >
                                <Skeleton variant="text" sx={{ height: '1rem', width: '20%' }} />

                                {MemberSkeleton}

                                <Skeleton
                                    variant="rounded"
                                    sx={{
                                        width: '10%',
                                        minWidth: '12rem',
                                        height: '2.5rem',
                                        marginTop: '0.5rem',
                                    }}
                                />
                            </Box>
                        </Box>
                        <Divider
                            sx={(theme) => ({
                                margin: `${theme.typography.generic.xxxxxLarge} ${theme.typography.generic.none}`,
                            })}
                        />
                        <Box>
                            <Skeleton variant="text" sx={{ height: '1.2rem', width: '20%' }} />
                            <List
                                sx={{
                                    display: 'flex',
                                    marginLeft: '-16px',
                                    flexWrap: {
                                        xs: 'wrap',
                                        md: 'nowrap',
                                    },
                                }}
                            >
                                {Array.from(Array(5).keys()).map((index) => (
                                    <ListItem key={index} sx={{ width: { xs: '100%', sm: '10rem', md: '100%' } }}>
                                        <Skeleton variant="text" sx={{ height: '1rem', width: { xs: '80%', md: '50%', sm: '80%' } }} />
                                    </ListItem>
                                ))}
                            </List>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
            {DocsSkeleton}
        </MainContainer>
    </>
);
